import React from 'react';
import ReactMarkdown, {defaultUrlTransform} from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import PropTypes from 'prop-types';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

/**
 * In the previous version of react-markdown we were using, HTML inside Markdown was parsed and rendered by default.
 * Now they are separating Markdown parsing from HTML parsing and sanitize HTML by default,
 * which means raw HTML in Markdown is no longer rendered automatically.
 * To restore support for features like tables and strikethrough, you now need to add the remark-gfm plugin.
 * To allow raw HTML inside Markdown to be rendered as real HTML elements (instead of escaped text), you must add the rehype-raw plugin.
 */
const Markdown = ({children, ...props}) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkBreaks]}
      rehypePlugins={[rehypeRaw]}
      urlTransform={(url) =>
        url.startsWith('tel:') || url.startsWith('mailto:')
          ? url
          : defaultUrlTransform(url)
      }
      {...props}
    >
      {children}
    </ReactMarkdown>
  );
};

Markdown.propTypes = {
  children: PropTypes.node.isRequired
};

export default Markdown;